import React from 'react';
import logo from '../../img/cemex.png';
import './styles/logo.scss';

function LogoComponent() {

  return (
    <div className="logo-component">
      <img src={logo} className="logo" />
    </div>
  );
}

export default LogoComponent;
